<ng-container *ngIf="loading">
    <div class="loading-bar">
        <tm1-progress-ring value="" min="0" max="1" size="regular" ></tm1-progress-ring>
</div>
</ng-container>


<div class = "topButton">
    <tm1-button routerLink = "/users/new">Create New User</tm1-button>
</div>

<div class="topborder">
    <tm1-text-field
      ngDefaultControl
      appearance="outline"
      inputsize="regular"
      label="Filter Results"
      placeholder="Email"
      type="text"
      [(ngModel)]="filterEmail"
      (input)="filterUsers()"
      charactercountlabel="character(s) left">
    </tm1-text-field>
  
    <tm1-text-field
      ngDefaultControl
      appearance="outline"
      inputsize="regular"
      label=&#8292;
      placeholder="Primary Venue"
      type="text"
      [(ngModel)]="filterPrimaryVenue"
      (input)="filterUsers()"
      charactercountlabel="character(s) left">
    </tm1-text-field>

    <tm1-text-field
    ngDefaultControl
    appearance="outline"
    inputsize="regular"
    label=&#8292;
    placeholder="Accessible Venues"
    type="text"
    [(ngModel)]="filterVenue"
    (input)="filterUsers()"
    charactercountlabel="character(s) left">
  </tm1-text-field>
  </div>

<div class="card-container">
    <tm1-card variant = "shadow">
      <tm1-data-grid
        grid-template-columns="5% 15% 5% 5% 1fr 7%"
        class="tm1-data-grid"
        generate-header=""
        focus-column-index="0"
        focus-row-index="0"
       >
        <tm1-data-grid-row class="tm1-data-grid-row" row-type="sticky-header">
          <tm1-data-grid-cell grid-column="1" cell-type="columnheader"
          ></tm1-data-grid-cell>
          <tm1-data-grid-cell grid-column="2" cell-type="columnheader"
            >Email</tm1-data-grid-cell
          >
          <tm1-data-grid-cell grid-column="3" cell-type="columnheader"
            >User Status</tm1-data-grid-cell
          >
          <tm1-data-grid-cell grid-column="4" cell-type="columnheader"
            >Venue Admin</tm1-data-grid-cell
          >
          <tm1-data-grid-cell grid-column="5" cell-type="columnheader"
            >Venues</tm1-data-grid-cell
          >
          <tm1-data-grid-cell grid-column="6" cell-type="columnheader"
            >Primary Venue</tm1-data-grid-cell
          >
        </tm1-data-grid-row>
        <tm1-data-grid-row class="tm1-data-grid-row">
          <ng-container
            *ngFor="let user of filteredUsers"
          >
          <tm1-data-grid-cell grid-column="1">
            <div class="icon-text-container">
              <tm1-text (click) = "editUser(user)" class="settingsText">Edit</tm1-text>
              
              <ng-container *ngIf="user.enabled == 'false'">
                <span class="settingsText" (click)="enableUser($event, user)">Enable</span>
              </ng-container>
          
              <ng-container *ngIf="user.enabled == 'true' || user.enabled == undefined">
                <span class="settingsText" (click)="disableUser($event, user)">Disable</span>
              </ng-container>
            </div>
          </tm1-data-grid-cell>
          
            <tm1-data-grid-cell grid-column="2">{{
              user.email
            }}</tm1-data-grid-cell>
            <ng-container
              *ngIf="user.enabled == 'true' || user.enabled == undefined"
            >
              <tm1-data-grid-cell grid-column="3"
                ><tm1-badge
                  appearance="accent"
                  baseColor="success"
                  circular="True"
                  >Enabled</tm1-badge
                ></tm1-data-grid-cell
              >
            </ng-container>
            <ng-container *ngIf="user.enabled == 'false'">
              <tm1-data-grid-cell grid-column="3"
                ><tm1-badge
                  appearance="accent"
                  baseColor="error"
                  circular="True"
                  >Disabled</tm1-badge
                ></tm1-data-grid-cell
              >
            </ng-container>
            <ng-container *ngIf="user.venueAdmin == true">
              <tm1-data-grid-cell grid-column="4"
                ><tm1-badge
                  appearance="accent"
                  baseColor="success"
                  circular="True"
                  >True</tm1-badge
                ></tm1-data-grid-cell
              >
            </ng-container>
            <ng-container *ngIf="user.venueAdmin == false">
              <tm1-data-grid-cell grid-column="4"
                ><tm1-badge
                  appearance="accent"
                  baseColor="error"
                  circular="True"
                  >False</tm1-badge
                ></tm1-data-grid-cell
              >
            </ng-container>
            <!-- <ng-container *ngIf = "user.primaryVenue == 'ticketmaster'">
                all
            </ng-container> -->
          <!-- <ng-container  *ngIf = "user.primaryVenue != 'ticketmaster'" > -->
            <tm1-data-grid-cell grid-column="5">{{
              user.venueText
            }}</tm1-data-grid-cell>
            <!-- </ng-container> -->
            <tm1-data-grid-cell grid-column="6">{{
              user.primaryVenueText
            }}</tm1-data-grid-cell>
          </ng-container>
        </tm1-data-grid-row>
      </tm1-data-grid>
    </tm1-card>
    </div>